$(document).ready(function () {

    var $input = $(".standalone-search input[type='search']"),
        $clearBtn = $(".standalone-search button[data-search='clear']"),
        $prevBtn = $(".standalone-search button[data-search='prev']"),
        $nextBtn = $(".standalone-search button[data-search='next']"),
        $searchBtn = $(".standalone-search button[data-search='search']"),
        // where to search
        content = new Mark($(".searchable-area")[0]),
        // current count
        $count = $('.standalone-search .count'),
        // collection of <mark> elements
        $results,
        // the class that will be appended to the current focused element
        currentClass = "current",
        // top offset for the jump
        offsetTop = 50,
        // the current index of the focused element
        currentIndex = 0;

    /**
     * Jumps to the element matching the currentIndex
     */
    function jumpTo() {
        if ($results.length) {
            var position,
                $current = $results.eq(currentIndex);
            $results.removeClass(currentClass);
            if ($current.length) {
                $current.addClass(currentClass);
                position = $current.offset().top - offsetTop;
                window.scrollTo(0, position);
            }
        }
    }

    function setCurrentPositionText() {
        $count.text(Math.min(currentIndex + 1, $results.length) + '/' + $results.length);
    }

    /**
     * Searches for the entered keyword in the `$content`.
     */
    $searchBtn.on('click', function () {
        var searchVal = $input.val();
        content.unmark({
            done: function () {
                content.mark(searchVal, {
                    "ignoreJoiners": true,
                    "acrossElements": true,
                    "separateWordSearch": false,
                    done: function () {
                        $results = content.find("mark");
                        currentIndex = 0;
                        setCurrentPositionText();
                        jumpTo();
                    }
                });
            }
        });
    });

    /**
     * Search on the enter key.
     */
    $input.on('keypress', function (e) {
        var enterKeyCode = 13;
        if (e.which === enterKeyCode) {
            $searchBtn.click();
        }
    });

    /**
     * Clears the search
     */
    $clearBtn.on("click", function () {
        content.unmark();
        $results = [];
        $count.text("0/0");
        $input.val("").focus();
    });

    /**
     * Next and previous search jump to
     */
    $nextBtn.add($prevBtn).on("click", function () {
        if ($results.length) {
            currentIndex += $(this).is($prevBtn) ? -1 : 1;
            if (currentIndex < 0) {
                currentIndex = $results.length - 1;
            }
            if (currentIndex > $results.length - 1) {
                currentIndex = 0;
            }
            $count.text(currentIndex + 1 + '/' + $results.length);
            jumpTo();
        }
    });

    /**
     * Set the initial search term if present.
     */
    if (typeof searchTerms !== 'undefined' && searchTerms !== null) {
        $input.val(searchTerms.join(' '));
        $searchBtn.click();
    }
});